var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOverview({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    className: "svg-icon",
    style: {
      width: "1em",
      height: "1em",
      verticalAlign: "middle",
      fill: "#827c78",
      overflow: "hidden"
    },
    viewBox: "0 0 1024 1024",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M111.204731 957.99061l0-37.289278 801.644773 0 0 37.289278L111.204731 957.99061M689.13635 902.056694l-93.215008 0-0.38988-478.959489L484.065787 342.769714 223.062332 454.633455l0 447.423239-111.857601 0 0-37.284161 74.570369 0L185.7751 435.991886l298.290687-130.506333 149.143808 111.857601 0 447.428356 55.926754 0L689.13635 902.056694zM278.211373 512.629333l131.279952-57.995879 0 74.568323-130.500193 55.932893L278.211373 512.629333 278.211373 512.629333zM409.491325 622.417809l0 74.573439-130.500193 37.280068-0.779759-70.427002L409.491325 622.417809zM278.991132 808.848848l130.500193-37.289278 0 93.212962L278.991132 864.772532 278.991132 808.848848zM726.419488 156.343791l0 745.711879 55.930847 0 0-679.710676L726.419488 156.343791zM484.065787 398.704654l0 503.352039 55.926754 0 0-466.064808L484.065787 398.704654zM912.849504 902.056694l-93.215008 0L819.634496 212.272591 726.419488 100.411921 372.20614 249.556753l0 55.9288-37.288255 37.284161L334.917886 230.912114 745.06515 63.127759l111.857601 149.145855 0 652.498918 55.926754 0L912.849504 902.056694z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOverview);
export default __webpack_public_path__ + "static/media/overview.be85701084ca57808ae9889e12300605.svg";
export { ForwardRef as ReactComponent };